import {
  SupportPlanBillableItemSids,
  SupportPlanBillableItemSidsType,
} from '@twiliointernal/e2-commons-shared-definitions';
import * as types from './types';

const logPrefixes = {
  accountSwitcherMenu: '[Account Switcher Menu]',
  unauthenticatedHeader: '[Header]',
  systemStatus: '[System Status]',
};

// Required for Paste navigation, MUST be unique
// See: https://paste.twilio.design/components/sidebar#skip-links
const navigationSkipLinks = {
  sidebar: 'osc-sidebar-skip-link-id',
  topbar: 'osc-topbar-skip-link-id',
  mainContent: 'osc-main-content-skip-link-id',
};

const topBarSupportPlanFeaturesDefault = {
  web: true,
  phone: false,
};

const topBarSupportPlanFeaturesPhone = {
  web: true,
  phone: true,
};

const supportPlanFeatureByBillingItemSidMap: Record<
  SupportPlanBillableItemSidsType,
  types.TopbarSupportPlanFeatures
> = {
  [SupportPlanBillableItemSids.developer]: topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.bootstrap]: topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.bootstrapAnnualPre2018]:
    topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.bootstrapOld]: topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.business]: topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.doGood]: topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.partnerAdvanced]:
    topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.personalized]: topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.personalizedPartnerMso]:
    topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.personalizedPartnerMss]:
    topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.personalizedPre2018]:
    topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.premium]: topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.premiumAnnualPre2018]:
    topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.premiumComplimentaryPre2018]:
    topBarSupportPlanFeaturesPhone,
  [SupportPlanBillableItemSids.premiumPhone]: topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.premiumPresalesPre2018]:
    topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.premium24x7]: topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.production]: topBarSupportPlanFeaturesDefault,
  [SupportPlanBillableItemSids.sendGridPersonalized]:
    topBarSupportPlanFeaturesPhone,
};

const footerLinks = [
  {
    label: 'Legal',
    url: 'https://www.twilio.com/legal/tos',
  },
  {
    label: 'Privacy',
    url: 'https://www.twilio.com/legal/privacy',
  },
  {
    label: 'Twilio.org',
    url: 'https://www.twilio.org',
  },
  {
    label: 'Press & Media',
    url: 'https://www.twilio.com/press',
  },
  {
    label: 'Signal',
    url: 'https://signal.twilio.com',
  },
  {
    label: 'Investors',
    url: 'https://investors.twilio.com/overview/default.aspx',
  },
  {
    label: 'Jobs',
    url: 'https://www.twilio.com/company/jobs',
  },
];

const reCaptchaLinks = [
  {
    label: 'Privacy Policy',
    url: 'https://policies.google.com/privacy',
  },
  {
    label: 'Terms of Service',
    url: 'https://policies.google.com/terms',
  },
];

const constants = {
  footerLinks,
  logPrefixes,
  navigationSkipLinks,
  reCaptchaLinks,
  supportPlanFeatureByBillingItemSidMap,
  topBarSupportPlanFeaturesDefault,
  topBarSupportPlanFeaturesPhone,
};

export default constants;
